import {AdUnitStatus, event, FloatingType, PlayerType, QueueManagerStatus} from "./const";

export const PageObserverEvents = {
	onVisibilityChange: 'onVisibilityChange',
	onPlayerInView: 'onPlayerInView',
};

export class PageObserver { // extends ImpressionDetector? remove code duplication
	constructor(container) {
		this.container = container;
		
		this.state = {
			isTabActive: document.visibilityState === 'visible',
			playerInView: false,
		};
		this.callbacks = {};
		this.observer = null;

		document.addEventListener('visibilitychange', this._onDocumentVisibilityChange);

		this._runPlayerObserver();
	}
	
	subscribe = (event, callback) => {
		if (this.callbacks[event]) {
			this.callbacks[event].push(callback);
		} else {
			this.callbacks[event] = [callback];
		}
	}
	
	unsubscribe = (event, callback) => this.callbacks[event] && this.callbacks[event].filter(cb => callback !== cb);

	_onDocumentVisibilityChange = () => {
		this.state.isTabActive = document.visibilityState === 'visible';
		
		const callbacks = this.callbacks[PageObserverEvents.onVisibilityChange];
		if (callbacks) {
			callbacks.forEach(cb => cb());
		}
	}

	_runPlayerObserver = () => {
		if (!this.container) return; // console.warn('container required');
		const options = {
			rootMargin: "0px",
			threshold: [.5],
		};

		const callback = (entries) => {
			entries.forEach((entry) => {
				const { intersectionRatio } = entry;
				this.state.playerInView = intersectionRatio >= 0.5;

				if (this.callbacks[PageObserverEvents.onPlayerInView] && this.callbacks[PageObserverEvents.onPlayerInView].length) {
					this.callbacks[PageObserverEvents.onPlayerInView].forEach((callback) => callback({ inView: this.state.playerInView }))
				}
			});
		};

		this.observer = new IntersectionObserver(callback, options);
		this.observer.observe(this.container);
	}
	
	destroy = () => {
		document.removeEventListener('visibilitychange', this._onDocumentVisibilityChange);
		if (this.observer) this.observer.disconnect();
	}
	
	get isTabActive() {
		return this.state.isTabActive;
	}

	get playerInView() {
		return this.state.playerInView;
	}
}
